<template>
    <b-modal v-model="show" :title="modalTitle" :hide-footer="true" @close="close">
        <p>URL des bannières des campagnes enfants :</p>
        <b-overlay :show="fetchingCampaignChildren">
            <p v-if="isCampaignStartDateToday" class="warning">⚠️ Vous êtes sur le point de lancer une campagne pour aujourd'hui</p>

            <b-form-group v-for="camp in validChildrenCampaign" :key="camp.campaign_code">
                <label class="campChildTitle">Campagne {{ camp.media_support_code }}</label>

                <div class="modifyCamp">
                    <span class="text-danger" v-if="!checkIfbannerExist">il n’y a pas de jeu de bannières associé à ce thème, uploadez votre bannière</span>
                </div>

                <div v-for="(file, index) in files" :key="index">
                    <div cols="6" class="d-flex align-items-center flex-wrap" style="margin-top: 5px" v-if="!checkIfbannerExist">
                        <b-alert show class="mr-1 mb-1 flex-grow-1 m-0 text-center" style="padding: 10px">{{ alertText(index) }}</b-alert>
                        <b-btn variant="primary" style="padding: 10px; margin-bottom: 15px" @click="openFileSelection(index)">
                            <feather-icon icon="UploadIcon" />
                            Importer un fichier
                        </b-btn>
                        <b-form-file ref="fileInput" v-model="files[index]" class="d-none" accept=".zip"></b-form-file>
                    </div>
                </div>

                <div class="modifyCamp">
                    <label>Account</label>
                    <b-form-select v-if="!account" v-model="selectedAccount" :options="accountOptions" @change="onAccountChange" />
                    <b-form-input v-else v-model="account" type="text" placeholder="Account Id" />
                </div>

                <div class="modifyCamp">
                    <label>PageId</label>
                    <b-form-select v-if="!account && filteredPageOptions.length > 0" v-model="pageId" :options="filteredPageOptions" placeholder="Select Page ID" @change="onPageChange" />
                    <!-- Here maybe  add possiblity to also have input ?-->
                    <!-- <b-btn v-if="creativesText[camp.campaign_code] && creativesText[camp.campaign_code].length < 3" @click="addTextInput(camp.campaign_code)">+</b-btn> -->
                    <b-form-input v-else v-model="pageId" type="text" placeholder="Page Id" />
                </div>

                <div class="modifyCamp">
                    <label>Audience</label>
                    <b-form-select v-if="!account && filteredAudienceOptions.length > 0" v-model="audience" :options="filteredAudienceOptions" placeholder="Select Audience" />
                    <b-form-input v-else v-model="audience" type="text" placeholder="Audience Id" />
                </div>
                <div class="modifyCamp" v-if="camp.media_support_code === 'FBF'">
                    <label> Titre du formulaire </label>
                    <b-form-input v-model="campFormTitle" type="text" aria-describedby="input-live-help input-live-feedback" autofocus placeholder="Titre du formulaire" />
                </div>
                <div class="modifyCamp">
                    <label> Titre </label>
                    <b-form-input v-model="title" type="text" aria-describedby="input-live-help input-live-feedback" autofocus placeholder="Titre" />
                </div>
                <div class="modifyCamp">
                    <label> Description </label>
                    <b-form-textarea v-model="description" type="text" aria-describedby="input-live-help input-live-feedback" autofocus placeholder="Description" />
                </div>

                <div class="modifyCamp">
                    <label :for="camp.media_support_code"> Url de la bannière </label>
                    <b-form-input
                        v-if="facebookMedia.includes(camp.media_support_code)"
                        v-model="creativesUrl[camp.campaign_code]"
                        :id="camp.campaign_code"
                        type="url"
                        :state="creativeUrlState[camp.campaign_code]"
                        aria-describedby="input-live-help input-live-feedback"
                        autofocus
                        required
                        placeholder="https://adcleek.com/"
                    />
                    <p v-else>URL non necessaire</p>
                    <b-form-invalid-feedback id="input-live-feedback"> URL incorrecte </b-form-invalid-feedback>
                </div>

                <div class="modifyCamp">
                    <label> Text </label>
                    <div v-if="creativesText[camp.campaign_code]" v-for="(text, index) in creativesText[camp.campaign_code]" :key="index">
                        <b-form-textarea class="input-text" v-model="creativesText[camp.campaign_code][index]" rows="3" placeholder="Text de la campagne" />
                    </div>
                    <b-btn v-if="creativesText[camp.campaign_code] && creativesText[camp.campaign_code].length < 3" @click="addTextInput(camp.campaign_code)">+</b-btn>
                </div>

                <div v-if="camp.media_support_code === 'FBF'">
                    <label class="campChildTitle mt-2">Formulaire</label>
                    <div class="modifyCamp">
                        <label> Titre </label>
                        <b-form-input v-model="formTitle" type="text" aria-describedby="input-live-help input-live-feedback" autofocus placeholder="Titre" />
                    </div>
                    <div class="modifyCamp">
                        <label> Description </label>
                        <b-form-textarea v-model="formDescription" type="text" aria-describedby="input-live-help input-live-feedback" autofocus placeholder="Description" />
                    </div>
                    <div class="modifyCamp mb-1">
                        <label> URL de la politique de confidentialité </label>
                        <b-form-input v-model="formPoliticUrl" type="url" aria-describedby="input-live-help input-live-feedback" autofocus placeholder="URL de la politique de confidentialité" />
                        <span class="text-danger" v-if="!formPoliticUrl">URL de politique de confidentialité manquante</span>
                    </div>

                    <div class="modifyCamp">
                        <label> Questionnaire </label>
                        <JsonEditor :content="defaultJsonContent" @onUpdateJsonContent="onUpdateJsonContent" />
                    </div>
                </div>

                <b-btn
                    style="margin-top: 20px"
                    id="btnCreateCampaignProvider"
                    v-if="camp.details && !camp.details.creaData"
                    :disabled="disableCreateStatus[camp.campaign_code] || !posNameExist"
                    @click="createProviderCampaign(camp.campaign_code)"
                    variant="primary"
                >
                    Créer
                </b-btn>
                <b-btn style="margin-top: 20px; margin-left: 10px" id="btnCreateCampaignProvider" @click="showAddAccount = !showAddAccount" variant="primary"> Add Page Id </b-btn>
                <div v-if="showAddAccount" class="modifyCamp" style="margin-top: 15px">
                    <label>Account ID</label>
                    <b-form-input v-model="account" type="text" placeholder="Account ID" />
                    <label>Page Name</label>
                    <b-form-input v-model="pageName" type="text" placeholder="Page Name" />

                    <label>Page ID</label>
                    <b-form-input v-model.number="pageId" type="number" placeholder="Page ID" />
                    <label>Audience</label>
                    <b-form-input v-model.number="audience" type="number" placeholder="Audience ID" />
                    <label>Audience Name</label>
                    <b-form-input v-model="audienceName" type="texte" placeholder="Audience Name" />

                    <label>DSA</label>
                    <b-form-checkbox v-model="dsa">Activer DSA</b-form-checkbox>
                    <b-btn style="margin-top: 20px; margin: 10px" variant="success" @click="onSave"> Enregistrer </b-btn>
                    <span v-if="successAddAccountMsg" style="color: green">Données enregistrer avec succès !!!</span>
                </div>
            </b-form-group>

            <br />
            <b-btn id="btnCreateCampaignProvider" v-if="showGlobalCreateStatus" :disabled="disableGlobalCreateStatus" @click="createProviderCampaign()" variant="primary">Créer</b-btn>
        </b-overlay>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import JsonEditor from '@/components/JsonEditor.vue';
    export default {
        components: {
            JsonEditor,
        },
        data() {
            return {
                btnCreateCampaignProviderState: false,
                description: '',
                title: '',
                campFormTitle: '',
                defaultJsonContent: { json: {} },
                updatedJsonContent: {},
                callToAction: '',
                formTitle: '',
                formDescription: '',
                formPoliticUrl: '',
                creativesUrl: {},
                creativesText: {},
                creativeUrlStatus: true,
                childrenCampaign: [],
                show: false,
                showAddAccount: false,
                successAddAccountMsg: false,
                fetchingCampaignChildren: true,
                campMedias: [],
                facebookMedia: ['FBF', 'FBK'],
                creas: [],
                accounts: [],
                audiences: [],
                account: '',
                audience: null,
                creaOptions: [],
                creaSelected: {},
                accountSelected: {},
                pageIdSelected: {},
                parentCampaign: {},
                showCreateStatus: {},
                showGlobalCreateStatus: false,
                validCamp: {},
                pageId: null,
                pageName: '',
                selectedAccount: '',
                accountOptions: [],
                pageOptions: [],
                audienceOptions: [],
                accountsPages: [],
                files: [null],
                dsa: 0,
                posNameExist: true,
                audienceName: '',
                themeConfigAudience: '',
            };
        },
        watch: {
            files: {
                handler(newFiles) {
                    if (newFiles[newFiles.length - 1]) {
                        this.files.push(null);
                    }
                },
                deep: true,
            },
        },
        computed: {
            ...mapGetters({
                successToast: 'app/successToast',
                errorToast: 'app/errorToast',
            }),
            filteredPageOptions() {
                return this.pageOptions.filter((page) => page.account === this.selectedAccount) || [];
            },
            filteredAudienceOptions() {
                return this.audienceOptions.filter((audience) => audience.pageId === this.pageId) || [];
            },
            modalTitle() {
                const firstValidChildCampaign = this.validChildrenCampaign[0];
                const details = firstValidChildCampaign && firstValidChildCampaign.details;
                const creaData = details && details.creaData;
                const code = creaData && creaData.code;
                return code ? 'Modifier le média chez facebook' : 'Créer le média chez facebook';
            },

            isCampaignStartDateToday() {
                const today = new Date().toISOString().slice(0, 10);
                return this.validChildrenCampaign.some((camp) => camp.start_date === today);
            },

            creativeUrlState() {
                let creativeUrlState = {};

                this.creativeUrlStatus = Object.keys(this.creativesUrl).length > 0 ? true : false;
                return creativeUrlState;
            },
            checkIfbannerExist() {
                this.file = null;
                const creaSelectedValue = Object.values(this.creaSelected)[0];
                if (creaSelectedValue) {
                    if (creaSelectedValue == 'ACCESS_CREA_CODE') return false;
                    const banner = this.creas.find((crea) => crea.crea_code === creaSelectedValue);
                    if (banner && banner.url_banner_code) {
                        const urlBannerCode = Object.values(banner.url_banner_code).filter((b) => b.trim() !== '');
                        return urlBannerCode.length > 0;
                    }
                    return false;
                }
                return true;
            },

            uploadedFiles() {
                return this.files.filter((file) => file !== null && file !== undefined);
            },

            disableCreateBtnIfBannerNotExist() {
                const bannerExists = this.checkIfbannerExist;
                return (!bannerExists && this.uploadedFiles.length) || (bannerExists && !this.uploadedFiles.length);
            },
            disableCreateStatus() {
                let disableCreateStatus = {};
                this.childrenCampaign.forEach((childCamp) => {
                    const creaInBase =
                        childCamp.details.creaData && childCamp.details.creaData.code
                            ? childCamp.details.creaData.code
                            : this.parentCampaign?.details?.crea_code
                            ? this.parentCampaign.details.crea_code
                            : '';
                    const creaUrlInBase = childCamp.details.creaData && childCamp.details.creaData.url ? childCamp.details.creaData.url : '';

                    if (this.creaSelected[childCamp.campaign_code] != creaInBase || (this.creativesUrl[childCamp.campaign_code] != creaUrlInBase && this.creativeUrlState[childCamp.campaign_code]))
                        disableCreateStatus[childCamp.campaign_code] = false;
                    else if (this.facebookMedia.includes(childCamp.media_support_code)) disableCreateStatus[childCamp.campaign_code] = false;
                    else disableCreateStatus[childCamp.campaign_code] = true;
                });

                return disableCreateStatus;
            },

            validChildrenCampaign() {
                const validChildrenCamps = this.childrenCampaign.filter((cc) => this.facebookMedia.includes(cc.media_support_code));
                return validChildrenCamps;
            },

            formatCreaOptions() {
                let creaOptions = [];
                if (this.creas.length) {
                    this.creas.forEach((c) => {
                        creaOptions.push({ item: c.crea_code, name: c.label });
                    });
                }
                return creaOptions;
            },

            disableGlobalCreateStatus() {
                let globalStatus = false;
                if (Object.keys(this.disableCreateStatus).length) {
                    const codes = Object.keys(this.disableCreateStatus);
                    globalStatus = this.disableCreateStatus[codes[0]];
                    for (const code in this.disableCreateStatus) {
                        globalStatus = globalStatus || this.disableCreateStatus[code];
                    }
                }
                return globalStatus;
            },
        },
        methods: {
            onUpdateJsonContent(newContent) {
                this.updatedJsonContent = newContent;
                console.log(newContent);

                console.log(this.updatedJsonContent);
            },

            async onSave() {
                const payload = {
                    page_name: this.pageName,
                    account: this.account.includes('act_') ? this.account : `act_${this.account}`,
                    page_id: this.pageId,
                    dsa: this.dsa,
                    audience: this.audience,
                    audience_name: this.audienceName,
                };
                try {
                    await this.$store.dispatch('app/postFacebookInfos', payload);
                    this.successAddAccountMsg = true;
                } catch (e) {
                    console.error(e);
                }
            },
            urlCheck(url) {
                const regex = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
                return url.match(regex) ? true : false;
            },
            close() {
                this.creativesUrl = {};
                this.creativesText = {};

                this.$set(this, 'childrenCampaign', []);
                this.$set(this, 'creas', []);
                this.$set(this, 'parentCampaign', {});
                this.$set(this, 'account', '');
                this.$set(this, 'pageId', '');
                this.$set(this, 'audience', '');
                this.$set(this, 'selectedAccount', '');
                this.$set(this, 'description', '');
                this.$set(this, 'title', '');
                this.$set(this, 'campFormTitle', '');
                this.$set(this, 'formTitle', '');
                this.$set(this, 'formDescription', '');
                this.$set(this, 'formPoliticUrl', '');
                this.$set(this, 'defaultJsonContent', { json: {} });
                this.$set(this, 'callToAction', '');

                this.show = false;
                this.fetchingCampaignChildren = true;
            },
            async open(campaignCode, childCampaignCode) {
                this.creaSelected = {};
                this.fetchingCampaignChildren = true;
                this.show = true;
                try {
                    const res = await this.$store.dispatch('app/genericGet', this.$store.state.app.apiBillingiUrl.concat('/children-campaign/?code=' + campaignCode));
                    for (const media of res.data) {
                        if (media.campaign_code === childCampaignCode) {
                            res.data = [media];
                        }
                    }
                    this.$set(this, 'childrenCampaign', res.data);

                    const creas = await this.$store.dispatch('app/getCreaByBrand', res.data[0].brand);
                    this.$set(this, 'creas', creas.data.data);

                    const parentCampRaw = await this.$store.dispatch('app/getCampaign', { campaignCode: campaignCode });
                    this.$set(this, 'parentCampaign', parentCampRaw.data);

                    const response = await this.$store.dispatch('app/getFacebookInfos', res.data);
                    this.accountsPages = response.data.pages;
                    const account = response.data.pages[0]?.info?.account || '';
                    const pageId = response.data.pages[0]?.info?.page_id || '';
                    const audience = response.data.pages[0]?.info?.audience || '';
                    this.accountOptions = response.data.accounts
                        .map((acc) => ({
                            value: acc.id,
                            text: `${acc.name} (${acc.id})`,
                        }))
                        .sort((a, b) => a.text.localeCompare(b.text));

                    this.pageOptions = response.data.pages.map((page) => ({
                        value: page.page_id || page.info?.page_id,
                        text: `${page.page_name || page.info?.page_name || 'No Audience Name'} (${page.page_id})`,
                        account: page.account || page.info?.account,
                    }));

                    this.audienceOptions = response.data.pages.map((item) => ({
                        value: item.audience || item?.info?.audience,
                        text: `${item.audience_name || item.info?.audience_name || 'No Audience Name'} (${item.audience || item.info?.audience})`,
                        pageId: item.page_id,
                    }));

                    this.$set(this, 'account', account);
                    this.$set(this, 'pageId', pageId);
                    this.$set(this, 'audience', audience);

                    if (this.childrenCampaign.length && Object.keys(this.parentCampaign).length) {
                        this.childrenCampaign.forEach((childCamp) => {
                            const initCreaCode =
                                childCamp.details.creaData && childCamp.details.creaData.code
                                    ? childCamp.details.creaData.code
                                    : this.parentCampaign?.details?.crea?.code && this.parentCampaign?.crea?.code !== 'ACCESS_CREA_CODE'
                                    ? this.parentCampaign?.details?.crea?.code
                                    : '';
                            this.$set(this.creaSelected, childCamp.campaign_code, initCreaCode);

                            const initCreaUrl = childCamp.details.creaData && childCamp.details.creaData.url ? childCamp.details.creaData.url : '';
                            this.$set(this.creativesUrl, childCamp.campaign_code, initCreaUrl);

                            this.$set(this.creativesText, childCamp.campaign_code, ['']);

                            if (childCamp.status == 0) this.showCreateStatus[childCamp.campaign_code] = true;
                            else this.showCreateStatus[childCamp.campaign_code] = false;

                            if (this.facebookMedia.includes(childCamp.media_support_code)) this.validCamp[childCamp.campaign_code] = true;
                            else this.validCamp[childCamp.campaign_code] = false;
                        });
                    }

                    this.preFillFacebookForm(this.parentCampaign.details, this.childrenCampaign[0]);
                } catch (e) {
                    console.error(e);
                } finally {
                    this.fetchingCampaignChildren = false;
                }
            },

            async preFillFacebookForm(parentCampaignDetails, childrenCampaign) {
                try {
                    const mediaCode = childrenCampaign.media_support_code;
                    const brand = childrenCampaign.brand;
                    const creaCode = parentCampaignDetails.crea.code;
                    const pointCode = childrenCampaign.point_code;

                    const themeConfig = await this.$store.dispatch('app/getFormattedThemeConfig', { brand, creaCode, mediaCode, posCode: pointCode });
                    const posInfos = await this.$store.dispatch('app/getPosInfos', { brand, pointCode });
                    const creaInfos = await this.$store.dispatch('app/getCreaInfos', { brand, creaCode });

                    // todo faire une table de correspondance plutot que des cas particulier foireux
                    let brandAccount = brand.replace('-', ' ');
                    // let brandAccount = brand === 'lexus' ? 'lexus v2' : brand.replace('-', ' ');

                    if (brand === 'mercedes-cars') {
                        brandAccount = 'mercedes';
                    }

                    const currentAccount = this.accountOptions.find((account) => account.text.toLowerCase().includes(brandAccount));
                    this.selectedAccount = currentAccount.value;

                    const posUrl = posInfos.details?.url;
                    const creaUrl = creaInfos.details?.landing_page_url;
                    const url = posUrl && creaUrl ? `${posUrl}${creaUrl}` : '';

                    if (themeConfig) {
                        const fields = themeConfig.details;

                        if (mediaCode === 'FBF') {
                            const city = parentCampaignDetails?.customer?.city;
                            const operation = parentCampaignDetails?.crea?.name;
                            const startDate = childrenCampaign.start_date
                                ? new Date(childrenCampaign.start_date).toLocaleDateString('fr-FR', { month: 'long', year: '2-digit' }).replace(' ', '')
                                : null;

                            if (brand && pointCode && city && operation && startDate && mediaCode) {
                                this.campFormTitle = `${brand}_${pointCode}_${city}_${operation}_${startDate}_${mediaCode}`.toUpperCase();
                            }

                            this.formPoliticUrl = posUrl;
                            this.formTitle = fields.formTitle;
                            this.formDescription = fields.formDescription;

                            this.$set(this, 'defaultJsonContent', {
                                json: themeConfig.details.form,
                            });
                            this.$set(this, 'updatedJsonContent', themeConfig.details.form);
                        }

                        this.themeConfigAudience = fields.audience;

                        const texts = [fields.text1, fields.text2, fields.text3];

                        this.onAccountChange();
                        this.onPageChange();
                        this.title = fields.title;
                        this.description = fields.description;
                        this.$set(this.creativesUrl, childrenCampaign.campaign_code, url);
                        this.$set(this.creativesText, childrenCampaign.campaign_code, texts);
                        this.callToAction = fields.callToAction;
                    }
                } catch (error) {
                    console.error(error);
                }
            },

            onAccountChange() {
                const selectedPage = this.filteredPageOptions.length ? this.filteredPageOptions[0] : null;

                this.pageId = selectedPage ? selectedPage.value : '';
                this.audience = selectedPage ? selectedPage.audience : '';
            },
            onPageChange() {
                const relatedAudience = this.audienceOptions.find((aud) => aud.value === this.themeConfigAudience);
                this.audienceOptions = [
                    {
                        value: this.themeConfigAudience,
                        text: relatedAudience ? relatedAudience.text : this.themeConfigAudience,
                        pageId: this.pageId,
                    },
                    ...this.audienceOptions.filter((aud) => aud.value !== this.themeConfigAudience),
                ];

                const selectedAudience = this.filteredAudienceOptions[0];
                this.audience = selectedAudience ? selectedAudience.value : '';
            },

            cleanQuestions(questions) {
                for (let question of questions) {
                    if (question.hasOwnProperty('personalData')) {
                        delete question.personalData;
                    }
                }
                return questions;
            },

            async createProviderCampaign(campCode = null) {
                this.$root.toggleGlobalLoading(true);
                const formData = new FormData();
                try {
                    const selectedCampaigns = campCode ? this.validChildrenCampaign.filter((vcc) => vcc.campaign_code === campCode) : this.validChildrenCampaign;
                    for (const campaign of selectedCampaigns) {
                        const code = campaign.campaign_code;
                        const matchingPage = this.accountsPages.find((p) => p.page_id === (this.pageId || ''));

                        const data = {
                            point_code: campaign.point_code,
                            brand: campaign.brand,
                            accountId: this.account || this.selectedAccount,
                            pageId: this.pageId || '',
                            audienceId: this.audience || '',
                            title: this.title || '',
                            description: this.description || '',
                            creaCode: this.creaSelected[campaign.campaign_code] || '',
                            creativeUrl: this.creativesUrl[campaign.campaign_code] || '',
                            creativeText: this.creativesText[campaign.campaign_code]?.filter((ct) => ct != '') || [],
                            dsa: matchingPage?.dsa === 1,
                            callToAction: this.callToAction ?? '',
                        };

                        if (campaign.media_support_code === 'FBF') {
                            data.formPoliticUrl = this.formPoliticUrl;
                            data.formTitle = this.formTitle;
                            data.formDescription = this.formDescription;
                            data.questions = this.updatedJsonContent || [];
                            data.questions = this.cleanQuestions(data.questions);
                        }

                        if (this.uploadedFiles.length) {
                            this.uploadedFiles.forEach((file) => {
                                formData.append('files', file);
                            });
                        }

                        formData.append('data', JSON.stringify(data));

                        if (campaign.media_support_code === 'FBF') {
                            await this.$store.dispatch('app/createFacebookCampaignForm', { code, formData });
                        } else {
                            await this.$store.dispatch('app/createFacebookCampaign', { code, formData });
                        }
                    }

                    this.close();

                    this.$toast({
                        component: 'toast',
                        props: {
                            title: 'Campagnes créées avec succès',
                            icon: 'CheckCircleIcon',
                            variant: 'success',
                        },
                    });
                } catch (e) {
                    console.error(e);
                    this.$toast({
                        component: 'toast',
                        props: {
                            title: 'Erreur lors de la création des campagnes',
                            icon: 'AlertCircleIcon',
                            variant: 'danger',
                        },
                    });
                } finally {
                    this.$root.toggleGlobalLoading(false);
                }
            },

            addTextInput(campaignCode) {
                if (!this.creativesText[campaignCode]) {
                    this.$set(this.creativesText, campaignCode, ['']);
                } else if (this.creativesText[campaignCode].length < 3) {
                    this.creativesText[campaignCode].push('');
                }
            },
            openFileSelection(index) {
                this.$refs.fileInput[index].$el.childNodes[0].click();
            },
            alertText(index) {
                const file = this.files[index];
                if (file) {
                    return file.name.length > 15 ? file.name.slice(0, 14) + '...zip' : file.name;
                }
                return 'Aucune bannière importée.';
            },
        },
    };
</script>

<style scoped>
    .users-list-container {
        box-sizing: border-box;
        padding: 24px;
        height: 100vh;
        overflow: auto;
    }

    .users-list {
        margin: 0 auto;
        max-width: calc(100% - 48px);
    }

    .input-text {
        margin-bottom: 10px;
    }

    .dynamic-table {
        width: 100%;
    }
</style>
